import { render, staticRenderFns } from "./listItem-old.vue?vue&type=template&id=b1b4609e&scoped=true&"
import script from "./listItem-old.vue?vue&type=script&lang=js&"
export * from "./listItem-old.vue?vue&type=script&lang=js&"
import style0 from "./listItem-old.vue?vue&type=style&index=0&id=b1b4609e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b4609e",
  null
  
)

export default component.exports